import React from 'react';
import { useMutation } from 'react-query';
import { useServiceClient } from 'common';
import { DefaultAppSettingsEndPoints, DefaultAppSettingsReactQueryKey } from './query-enum';
import { useConfigScopeSelectors } from 'modules/core/scopes';

export const useClearAppListQuery = () => {
    const { postData } = useServiceClient();
    const { selectCurrentUserDetails } = useConfigScopeSelectors();
    const currentUserDetails = selectCurrentUserDetails();

    const clearAppList = React.useCallback(() => postData(`${DefaultAppSettingsEndPoints.CLEAR_APP_LIST}${currentUserDetails.userName.replace(/\\/g, '_')}`).then((res) => res), [currentUserDetails.userName, postData]);
    return useMutation(DefaultAppSettingsReactQueryKey.CLEAR_APP_LIST, clearAppList);
};
